export default function Footer() {
  return (
    <footer className="bg-dark text-white py-4 px-4 text-center text-sm">
      <p className="text-white/70">
        © 2025 Restauracja Magiczna | Wszelkie prawa zastrzeżone | Realizacja:{" "}
        <a
          href="https://www.suplexweb.pl/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-white"
        >
          SuplexWeb.pl
        </a>
      </p>
    </footer>
  );
}
